import React, {useEffect, useRef} from 'react'
import './modal-dropdown-menu-fall-2023.css'
const ModalDropdownMenuFall2023 = ({menuItems, setOpenDropdown}) => {

    const modalRef = useRef()
    useEffect(() => {
        const closeModal = (e) => {
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                setOpenDropdown(false)
            }
        }
        document.addEventListener('mousedown', closeModal)
        return () => {
            document.removeEventListener('mousedown', closeModal)
        }
    }, [])

    return (
        <div ref={modalRef} className='modal-dropdown-menu-fall-2023__wrapper'>
            {menuItems.map((item, index) => <div className='modal-dropdown-menu-fall-2023__menu-item' key={index} onClick={item.onClick}>{item.label}</div>)}
        </div>
    )
}
export default ModalDropdownMenuFall2023